const POLICY_CATEGORY = 'policies'

export const POLICY_EVENTS = {
  POLICY_CATALOGUE_TILE_CLICKED: {
    action: 'Policy catalogue tile clicked',
    category: POLICY_CATEGORY,
  },
}
